import { Item } from "react-html-email";
import React from "react";

export const BodyContent = (props) => (
  <Item style={props.styles.item}>
    <props.bodyContentComponent />
  </Item>
);
